module.exports = __webpack_public_path__ + "files/96f786d7ac05260562a6d38fc9e98ab5.png";